export default {
  methods: {
    getPicture (id, avatar=false, full= false) {
      if (avatar){
        try {

          if(full)
            return require(`@/assets/img/avatars/${id}.png`)
          return require(`@/assets/img/avatars/${id}.png`)
        } catch (_) {
          return require('@/assets/img/avatars/avatar.png')
        }
      }
    },
    translateIsoCountry (iso) {
      return this.$te(`country.${iso}`) ? this.$t(`country.${iso}`) : iso
    },
  }
}
